import React from 'react';
import { CloseOutlined } from '@mui/icons-material';
import { IconButton, Modal } from '@mui/material';
import { useModalStore } from '../store/useModalStore';

export const CustomModals = () => {

    const { visible, component, width, height, closeModal } = useModalStore();

    return (
        <Modal
            open={ visible }
            aria-labelledby="simple-modal-titles"
            aria-describedby="simple-modal-descriptions"
            sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
        >   
            <div style={{ position: 'relative' }}>
                <IconButton style={{ position: 'absolute', top: 15, right: 15, zIndex: 99999999999999 }} onClick={ closeModal }>
                    <CloseOutlined fontSize="small" />
                </IconButton>

                <div 
                    style={{
                        background: '#fff',
                        width,
                        height,
                        maxWidth: 900,
                        maxHeight: '95dvh',
                        borderRadius: 6,
                        margin: 15,
                        position: 'relative',
                        overflowY: 'auto'
                    }}
                >
                    { component }
                </div>
            </div>
        </Modal>
    );
}